/**
 * Relative quality of indication
 * tag: 25
 * @readonly
 * @enum {string} (char)
 */
export enum IOIQltyInd {
  /** High */
  High = 'H',
  /** Low */
  Low = 'L',
  /** Medium */
  Medium = 'M',
}
